import React from "react";
import { useHistory } from "react-router-dom";
import doc from "./document.svg";
import { routes } from "../../../App";
import css from "../../AutoSamplete.module.css";

function SuggestItem({
  result,
  getSpecificContract,
  contract_id,
  setTextInput
}) {
  const history = useHistory();
  const { contract_name, summary } = result;

  function handleClick() {
    getSpecificContract(contract_id);
    setTextInput("");
    // history.push(`${routes.contracts}/${contract_id}`);
  }
  return (
    <div className={css.suggestdiv} onClick={handleClick}>
      <img src={doc} className={css.suggestitemdocpic} alt="document"></img>
      <li className={css.suggestitemcontractname}>{contract_name}</li>
      <li className={css.suggestitemsummary}>{summary}</li>
    </div>
  );
}

export default SuggestItem;
